import { Component, OnDestroy } from '@angular/core';
import { timezones } from './timezones';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../shared/models/User';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { GCValidators } from '../../shared/validators/gc-validator';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  timezones: any[] = timezones;
  currentTab: number = 0;

  user: User = {} as User;

  profileForm = new FormGroup({
    title: new FormControl('none', [Validators.required]),
    prename: new FormControl('', [Validators.required, Validators.minLength(2)]),
    surname: new FormControl('', [Validators.required, Validators.minLength(2)]),
    alias: new FormControl('', [Validators.maxLength(30)]),
    timezone: new FormControl('', [Validators.required]),
    language: new FormControl('', [Validators.required]),
    caption: new FormControl('', []),
    emailFormat: new FormControl('', [Validators.required]),
  });

  passwordForm = new FormGroup({
    oldPassword: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, GCValidators.validatePassword()]),
    confirmPassword: new FormControl('', [Validators.required, GCValidators.validatePasswordComparison()]),
  });

  constructor(private userService: UserService, private snackBar: MatSnackBar, private translate: TranslateService) {
    this.profileForm.disable();
    userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe((user) => {
      if (!user) {
        return;
      }

      this.user = user;
      this.profileForm.controls['title'].setValue(user.gender === true ? 'male' : user.gender === false ? 'female' : 'none');
      this.profileForm.controls['prename'].setValue(user.firstName);
      this.profileForm.controls['surname'].setValue(user.lastName);
      this.profileForm.controls['alias'].setValue(user.alias);
      this.profileForm.controls['timezone'].setValue(user.timeZone);
      this.profileForm.controls['language'].setValue(user.language);
      this.profileForm.controls['caption'].setValue(user.enableCaptions);
      this.profileForm.controls['emailFormat'].setValue(user.emailFormat);
      this.profileForm.enable();
    });
  }

  saveSettings() {
    if (this.profileForm.valid) {
      this.profileForm.disable();
      this.userService
        .updateUser({
          firstName: this.profileForm.value.prename,
          lastName: this.profileForm.value.surname,
          gender: this.profileForm.value.title === 'male' ? true : this.profileForm.value.title === 'female' ? false : null,
          language: this.profileForm.value.language,
          enableCaptions: this.profileForm.value.caption || false,
          timeZone: this.profileForm.value.timezone,
          alias: this.profileForm.value.alias,
          emailFormat: this.profileForm.value.emailFormat,
        })
        .then((result) => {
          this.profileForm.enable();
          this.translate
            .get('SETTINGS.ALERT.saveSuccess')
            .takeUntil(this.ngUnsubscribe)
            .subscribe((message: string) => {
              this.snackBar.open(message, null, {
                verticalPosition: 'bottom',
                duration: 4000,
                panelClass: ['b2a-success', 'bottom'],
              });
              this.userService.getThisUser();
            });
        })
        .catch((error) => {
          this.profileForm.enable();
          this.translate
            .get('SETTINGS.ALERT.saveError')
            .takeUntil(this.ngUnsubscribe)
            .subscribe((message: string) => {
              this.snackBar.open(message, null, {
                verticalPosition: 'bottom',
                duration: 4000,
                panelClass: ['b2a-error', 'bottom'],
              });
            });
        });
    }
  }

  submitPasswordForm(e) {
    e.preventDefault();

    if (this.passwordForm.valid) {
      this.passwordForm.disable();
      this.userService
        .setPassword(this.passwordForm.value.oldPassword, this.passwordForm.value.password)
        .then((result) => {
          this.passwordForm.reset();
          this.passwordForm.enable();
          this.translate
            .get('SETTINGS.ALERT.saveSuccess')
            .takeUntil(this.ngUnsubscribe)
            .subscribe((message: string) => {
              this.snackBar.open(message, null, {
                verticalPosition: 'bottom',
                duration: 4000,
                panelClass: ['b2a-success', 'bottom'],
              });
            });
        })
        .catch((error) => {
          this.passwordForm.enable();
          this.translate
            .get('SETTINGS.ALERT.saveError')
            .takeUntil(this.ngUnsubscribe)
            .subscribe((message: string) => {
              this.snackBar.open(message, null, {
                verticalPosition: 'bottom',
                duration: 4000,
                panelClass: ['b2a-error', 'bottom'],
              });
            });
        });
    }
  }

  cancelSave(e) {
    e.preventDefault();
    this.userService.getThisUser();
    this.passwordForm.reset();
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/settings/settings.component.ts